module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Présentation","b":"Trigramme","c":"Années d\u0027expérience","d":"Prénom","e":"Nom de famille","f":"Niveau de diplôme","g":"Année de naissance","h":"Titre du candidat"},"en":{"a":"Presentation","b":"Trigram","c":"Years of experience","d":"First name","e":"Last name","f":"Top degree","g":"Year of birth","h":"Title of the candidate"}}')
  delete Component.options._Ctor
}
